export const GET_UX_JOURNEY_CONFIG_SUCCESS = 'GET_JOURNEY_VARIABLES_SUCCESS'
